import { DateRangePicker, type DateRangePickerProps } from './date-range-picker'

export type DateTimeRangePickerProps = Omit<DateRangePickerProps, 'includeTime'>

/** Timestamp range variant built on the shared MADAR range calendar. */
export function DateTimeRangePicker(props: DateTimeRangePickerProps) {
 return <DateRangePicker {...props} includeTime />
}
